/**
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 2021-Ene-15
 *
 **/

import {httpClient} from "./http-client";

/**
 * Consulta lista de estados, municipios y colonias
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const getFiscalContacts = (data) => httpClient.post('contacto/listado', data)

const getAddressCatalog = (data) => httpClient.post('contacto/address_catalog', data)

const creatFiscalContact = (data) => httpClient.post('contacto/crear', data)

const deleteFiscalContact = (data) => httpClient.post('contacto/eliminar', data)

const updateFiscalContact = (data) => httpClient.post('contacto/actualizar', data)

export {
    getFiscalContacts,
    getAddressCatalog,
    creatFiscalContact,
    deleteFiscalContact,
    updateFiscalContact
}